import React, { useEffect } from "react";

const CarouselSlider = ({ slides }) => {
  useEffect(() => {
    // Wait for DOM to be ready and Swiper to be available
    const initializeSlider = () => {
      const slideshowElement = document.querySelector(".tf-sw-slideshow");
      if (!window.Swiper || !slideshowElement) {
        setTimeout(initializeSlider, 100);
        return;
      }

      // Destroy previous instance to reflect updated slides length
      if (slideshowElement.swiper) {
        try {
          slideshowElement.swiper.destroy(true, true);
        } catch (e) {
          // no-op
        }
      }

      const preview = parseInt(slideshowElement.dataset.preview) || 1;
      const tablet = parseInt(slideshowElement.dataset.tablet) || 1;
      const mobile = parseInt(slideshowElement.dataset.mobile) || 1;
      const centered = slideshowElement.dataset.centered === "true";
      const space = parseInt(slideshowElement.dataset.space) || 0;
      const loop = slideshowElement.dataset.loop === "true";
      const autoplay = slideshowElement.dataset.autoPlay === "true";
      const delay = parseInt(slideshowElement.dataset.delay) || 2000;
      const speed = parseInt(slideshowElement.dataset.speed) || 1000;

      new window.Swiper(".tf-sw-slideshow", {
        slidesPerView: mobile,
        spaceBetween: space,
        centeredSlides: centered,
        loop: loop,
        autoplay: autoplay
          ? {
              delay: delay,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
        speed: speed,
        pagination: {
          el: ".sw-pagination-slider",
          clickable: true,
        },
        slidesPerGroup: 1,
        observer: true,
        observeParents: true,
        breakpoints: {
          768: {
            slidesPerView: tablet,
            spaceBetween: space,
            centeredSlides: false,
          },
          1150: {
            slidesPerView: preview,
            spaceBetween: space,
            centeredSlides: centered,
          },
        },
      });
    };

    initializeSlider();

    // Cleanup on unmount
    return () => {
      const slideshowElement = document.querySelector(".tf-sw-slideshow");
      if (slideshowElement && slideshowElement.swiper) {
        try {
          slideshowElement.swiper.destroy(true, true);
        } catch (e) {
          // no-op
        }
      }
    };
  }, [slides]);

  return (
    <>
      <style>
        {`
          /* Make carousel slider button blue */
          .tf-slideshow .box-content .tf-btn.btn-fill {
            background-color: #0e5aa7 !important;
            border-color: #0e5aa7 !important;
            color: #ffffff !important;
          }
          
          .tf-slideshow .box-content .tf-btn.btn-fill:hover {
            background-color: #0c4a8a !important;
            border-color: #0c4a8a !important;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(14, 90, 167, 0.3);
          }
          
          .tf-slideshow .box-content .tf-btn.btn-fill:active {
            background-color: #0a3a6d !important;
            border-color: #0a3a6d !important;
          }
          
          /* Match BannerCollection width and height */
          .carousel-slider-wrapper {
            max-width: 100%;
            margin: 0 auto;
            padding: 0 10px;
          }
          
          .carousel-slider-wrapper .tf-slideshow {
            max-width: 100%;
            margin: 0 auto;
            border-radius: 20px;
            overflow: hidden;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
            width: 100%;
          }
          
          @media (min-width: 576px) {
            .carousel-slider-wrapper {
              padding: 0 20px;
            }
          }
          
          @media (min-width: 768px) {
            .carousel-slider-wrapper {
              padding: 0 30px;
            }
          }
          
          @media (min-width: 992px) {
            .carousel-slider-wrapper {
              padding: 0 40px;
            }
          }
          
          @media (min-width: 1200px) {
            .carousel-slider-wrapper {
              padding: 0 50px;
            }
          }
          
          .carousel-slider-wrapper .tf-slideshow .swiper,
          .carousel-slider-wrapper .tf-slideshow .swiper-wrapper,
          .carousel-slider-wrapper .tf-slideshow .swiper-slide,
          .carousel-slider-wrapper .tf-slideshow .wrap-slider {
            border-radius: 20px;
            overflow: hidden;
          }

          /* Match BannerCollection height behavior - natural image height */
          .carousel-slider-wrapper .tf-slideshow .wrap-slider {
            position: relative !important;
            display: block !important;
            width: 100% !important;
            padding-top: 0 !important;
          }

          .carousel-slider-wrapper .tf-slideshow .wrap-slider > a {
            display: block !important;
            width: 100% !important;
            position: relative !important;
          }

          .carousel-slider-wrapper .tf-slideshow .wrap-slider img {
            width: 100% !important;
            height: auto !important;
            display: block !important;
            object-fit: cover !important;
          }

          @media (max-width: 767px) {
            .carousel-slider-wrapper .tf-slideshow .wrap-slider img {
              min-height: 300px !important;
            }
          }

          .page-home .desktop-carousel-wrapper .carousel-slider-wrapper .tf-slideshow .wrap-slider .box-content {
            display: none !important;
            height: 0 !important;
            width: 0 !important;
            margin: 0 !important;
            padding: 0 !important;
            overflow: hidden !important;
          }
          
          @media (max-width: 991px) {
            .carousel-slider-wrapper {
              padding: 0 12px;
            }
            
            .carousel-slider-wrapper .tf-slideshow {
              border-radius: 12px;
            }
            
            .carousel-slider-wrapper .tf-slideshow .swiper,
            .carousel-slider-wrapper .tf-slideshow .swiper-wrapper,
            .carousel-slider-wrapper .tf-slideshow .swiper-slide,
            .carousel-slider-wrapper .tf-slideshow .wrap-slider {
              border-radius: 12px;
            }
          }
          
          @media (max-width: 575px) {
            .carousel-slider-wrapper {
              padding: 0 8px;
            }
            
            .carousel-slider-wrapper .tf-slideshow {
              border-radius: 8px;
            }
            
            .carousel-slider-wrapper .tf-slideshow .swiper,
            .carousel-slider-wrapper .tf-slideshow .swiper-wrapper,
            .carousel-slider-wrapper .tf-slideshow .swiper-slide,
            .carousel-slider-wrapper .tf-slideshow .wrap-slider {
              border-radius: 8px;
            }
          }
        `}
      </style>
      <div className="carousel-slider-wrapper">
        <div className="tf-slideshow slider-women slider-effect-fade position-relative">
          <div
            dir="ltr"
            className="swiper tf-sw-slideshow"
            data-preview="1"
            data-tablet="1"
            data-mobile="1"
            data-centered="false"
            data-space="0"
            data-loop="true"
            data-auto-play="true"
            data-delay="2000"
            data-speed="1000"
          >
            <div className="swiper-wrapper">
              {slides.map((slide, index) => (
                <div key={index} className="swiper-slide swiper-slide-header">
                  <div className="wrap-slider">
                    <a
                      href={slide.buttonLink || "/shop-default"}
                      style={{
                        display: "block",
                        width: "100%",
                        height: "100%",
                        textDecoration: "none",
                        cursor: "pointer",
                      }}
                    >
                      <img
                        className="lazyload"
                        data-src={slide.image}
                        src={slide.image}
                        alt={slide.alt}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          display: "block",
                        }}
                      />
                    </a>
                    <div className="box-content" style={{ display: "none" }}>
                      <div className="container">
                        <h1 className="fade-item fade-item-1">{slide.title}</h1>
                        <p className="fade-item fade-item-2">
                          {slide.description}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="wrap-pagination">
            <div className="container">
              <div className="sw-dots sw-pagination-slider justify-content-center"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CarouselSlider;
